import { SORTIE_EXPORT_ORIGIN, SORTIE_EXPORT_TYPE } from './sortie.enums'

export const ADD_SORTIE_FORM = 'ADD_SORTIE_FORM'

export const UPDATE_COMMENTAIRE_SORTIE_FORM = 'UPDATE_COMMENTAIRE_SORTIE_FORM'

export const EXPORT_SORTIE_FORM = 'EXPORT_SORTIE_FORM'

export const SORTIES_DATATABLE = 'SORTIES_DATATABLE'

export const FORM_FIELDS = {
	CULTURE: 'idCulture',
	QUANTITE: 'quantite',
	TYPE_CONDITIONNEMENT: 'typeConditionnement',
	QUANTITE_UC: 'quantiteUc',
	DATE_SORTIE: 'dateSortie',
	DEBOUCHE: 'idDebouche',
	COMMENTAIRE: 'commentaire'
}

export const EXPORT_FORM_FIELDS = {
	EXPORT_TYPE: 'exportType',
	CLIENT: 'idClient',
	SEMAINE: 'semaine'
}

export const EXPORT_TYPE_BY_ORIGIN = {
	[SORTIE_EXPORT_ORIGIN.PLANIFICATION_TACHES]: [SORTIE_EXPORT_TYPE.RECOLTE_THEORIQUE_SEMAINE],
	[SORTIE_EXPORT_ORIGIN.SORTIE]: [SORTIE_EXPORT_TYPE.BON_LIVRAISON, SORTIE_EXPORT_TYPE.TABLEAU_SORTIE]
}